// app/components/commonCodes/CommonCodeTable.jsx
import React from 'react';
import { Edit2, Trash2 } from 'lucide-react';

const CommonCodeTable = ({ codes, onEdit, onDelete }) => {
    return (
        <div className="p-4 overflow-x-auto">
            <div className=' border mb-6 rounded-md'>
            <table className="w-full">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500 ">
                            Code
                        </th>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500 ">
                            Value
                        </th>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500">
                            Description
                        </th>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500 ">
                            Order
                        </th>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500">
                            Status
                        </th>
                        <th className="px-6 py-4 text-left text-1x1 font-medium text-black-500">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {codes.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                                No codes found
                            </td>
                        </tr>
                    ) : (
                        codes.map((code) => (
                            <tr key={code.id} className="hover:bg-gray-50">
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600">
                                    {code.code}
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600">
                                    {code.value}
                                </td>
                                <td className="px-6 py-3 text-1x1 text-gray-500">
                                    {code.description || '-'}
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600">
                                    {code.display_order}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                    <span className={`px-2 py-1 text-xs rounded-md ${code.is_active
                                        ? 'bg-green-100 text-green-800'
                                        : 'bg-red-100 text-red-800'
                                        }`}>
                                        {code.is_active ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => onEdit(code)}
                                            className="text-blue-600 hover:text-blue-800"
                                        >
                                            <Edit2 className="w-4 h-4" />
                                        </button>
                                        <button
                                            onClick={() => onDelete(code.id)}
                                            className="text-red-600 hover:text-red-800"
                                        >
                                            <Trash2 className="w-4 h-4" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default CommonCodeTable; 